import { GeoPoint, IGeoPoint } from './GeoPoint'
import { Media } from './Media'

export const PageStatus = ['pending', 'published'] as const
export const PageTypes = [ 'place', 'organization', 'other' ] as const

export interface IPage {
  _id: string
  slug: string
  
  status: typeof PageStatus[number]
  types: (typeof PageTypes[number])[]

  name: string
  summary: string
  description: string

  logo: Media | null
  banner: Media | null
  medias: Media[]

  isSponsored: boolean
  offers: {
    title: string
    summary: string
    description: string
    secret: string
  }[]

  address: string
  location: string
  geolocation: IGeoPoint

  admins: string[]
  places: string[]
  
  owner: string

  createdAt: Date

  // VIRTUALS

}

export interface Page extends IPage {}

export class Page implements IPage {
  geolocation: GeoPoint
  
  constructor(props: IPage) {

    Object.assign(this, {
      ...props,
      logo: props.logo ? new Media(props.logo) : null,
      geolocation: new GeoPoint(props.geolocation),
      banner: props.banner ? new Media(props.banner) : null,
      medias: (props.medias ?? []).map(media => new Media(media))
    })
  }
}